import { MAX_AMOUNT, MAX_CODE_LENGTH } from "./constants";

export function sanitize(str) {
  if (!str || typeof str !== "string") return "";
  return str.replace(/&(#?[a-zA-Z0-9]+);/g,"").replace(/<[^>]*>/g,"").replace(/[<>"'`&;(){}\[\]]/g,"").replace(/javascript:/gi,"").replace(/on\w+\s*=/gi,"").trim().slice(0, 500);
}

export function validAmount(n) {
  const num = typeof n === "string" ? parseFloat(n) : n;
  return typeof num === "number" && Number.isFinite(num) && num > 0 && num <= MAX_AMOUNT;
}

export function sanitizeCode(str) {
  if (!str || typeof str !== "string") return "";
  return str.replace(/[^A-Za-z0-9]/g, "").slice(0, MAX_CODE_LENGTH);
}

export function validDate(dateStr) {
  if (!dateStr) return false;
  const d = new Date(dateStr);
  const t = new Date(); t.setHours(23, 59, 59, 999);
  return d instanceof Date && !isNaN(d) && d <= t;
}

export function isDuplicateExpense(expenses, amount, description) {
  const ago = Date.now() - 60000;
  return expenses.some(e => e.amount === amount && e.description === description && new Date(e.createdAt).getTime() > ago);
}

const ts = {};
export function isThrottled(key, ms = 500) {
  const now = Date.now();
  if (ts[key] && now - ts[key] < ms) return true;
  ts[key] = now; return false;
}

export function validatePriceResponse(data, currency) {
  if (!data || typeof data !== "object") return {};
  const safe = {};
  for (const [id, v] of Object.entries(data)) {
    if (typeof id !== "string" || id.length > 50 || !v || typeof v !== "object") continue;
    const price = v[currency];
    if (typeof price !== "number" || !Number.isFinite(price)) continue;
    const ch = v[currency + "_24h_change"], mc = v[currency + "_market_cap"];
    safe[id] = { [currency]: price, [currency + "_24h_change"]: typeof ch === "number" && Number.isFinite(ch) ? ch : 0, [currency + "_market_cap"]: typeof mc === "number" && Number.isFinite(mc) ? mc : 0 };
  }
  return safe;
}

export function formatINR(a) {
  if (a === undefined || a === null) return "\u20B90";
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(a);
}

export function formatNum(n, d = 0) {
  if (!n && n !== 0) return "0";
  return Number(n).toLocaleString("en-IN", { minimumFractionDigits: d, maximumFractionDigits: d });
}

export function formatDate(ds) { return new Date(ds).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }); }
export function shortDate(ds) { return new Date(ds).toLocaleDateString("en-IN", { day: "2-digit", month: "short" }); }
export function today() { return new Date().toISOString().split("T")[0]; }
export function currentMonth() { const d = new Date(); return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0"); }

export function timeAgo(ds) {
  const m = Math.floor((Date.now() - new Date(ds).getTime()) / 60000);
  if (m < 1) return "Just now";
  if (m < 60) return m + "m ago";
  const h = Math.floor(m / 60);
  if (h < 24) return h + "h ago";
  return Math.floor(h / 24) + "d ago";
}
